module.exports = __webpack_public_path__ + "arts-b1747a7e7db5b622a24ade9f899f6d58.svg";